export default {
  columns: {
    version: 'Versão',
    signed_at: 'Assinado em',
    internal_note: 'Nota interna',
    signature_provider: 'Fornecedor de assinatura',
    file: 'Documento',
    actions: 'Ações',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Ainda não há histórico de assinaturas disponível',
    providers: {
      selfhosted: 'Auto-alojado',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Pré-visualizar',
    download: 'Transferir',
  },
};
